// @ts-nocheck

import UserItemsTitleBar from 'app/shared/modules/user-items/UserItemsTitleBar';
import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';

import { Component } from 'react';
import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Head from 'react-helmet';
import map from 'lodash/map';
import cx from 'classnames';
import omit from 'lodash/omit';
import assign from 'lodash/assign';
import uniqBy from 'lodash/uniqBy';
import get from 'lodash/get';

// Actions
import RouteActions from 'app/shared/flux/actions/RouteActions';
import UserItemActions from 'app/shared/flux/actions/UserItemActions';

// Components
import Button from 'app/shared/core/Button';
import Center from 'app/shared/modules/Center';
import Container from 'app/shared/core/Container';
import Pagination from 'app/shared/modules/Pagination';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import Select from 'app/shared/core/Select';
import Spinner from 'app/shared/modules/Spinner';
import Text from 'app/shared/core/Text';
import TabGroup from 'app/shared/modules/TabGroup';
import TabItem from 'app/shared/modules/TabItem';

// Misc / Utils
import './style.scss';
import * as S from './styles';
import pathsManifest from 'app/shared/utils/pathsManifest';
import routeUtils from 'app/shared/utils/routeUtils';
import controller from './controller';
import isEmpty from 'lodash/isEmpty';
import constants from 'app/shared/constants/ConstantsBundle';
import { emitTrackSortListingsEvent } from 'app/shared/models/Clickstream/ListingsClickstreamEvents';
import { emitTrackViewMyListPageEvent } from 'app/shared/models/Clickstream/PageViewEvents';
import { registerClientProfilerPage } from 'app/shared/utils/clientProfiler';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';

const logger = getGlobalLogger('pages/myListPage');
const PAGE_SIZE = 20;

const StyledTabGroup = styled(TabGroup)`
  ${stacked._4x};
`;
const StyledDarkText = styled(Text)`
  color: ${colors['$hpx-grey-600']};
`;
class MyListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      loading: props.isLoggedIn === true,
      sortBy: 'default',
    };

    emitTrackViewMyListPageEvent();
    registerClientProfilerPage('hotpads-my-list');
  }

  componentDidMount() {
    const offset = parseInt(this.props.query.start) || 0;
    this.getUserItems(
      [constants.FAVORITE, constants.INQUIRY, constants.FAVORITE_AND_INQUIRY],
      offset,
      this.state.sortBy,
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const prevIndex = parseInt(prevProps.query.index) || 0;
    const currIndex = parseInt(this.props.query.index) || 0;
    const offset = parseInt(this.props.query.start) || 0;

    if (prevState.sortBy !== this.state.sortBy || prevIndex !== currIndex) {
      this.getUserItems(controller.getUserItemTypesFromIndex(currIndex), offset, this.state.sortBy);
    }
  }

  // TODO: refactor away from accepting types as an argument
  getUserItems = (types, offset, sortBy) => {
    this.setState({
      loading: true,
    });
    window.scrollTo(0, 0);

    // hardcoding favorite,inquiry query because query specifically for an inquiry will not return
    // the correct userItemTypes from server (unless we ask for them specifically)
    this.getUserItemsPromise(constants.FAVORITE_AND_INQUIRY, offset, sortBy).then(() => {
      this.setState({
        loading: false,
      });
    });
  };

  getUserItemsPromise = (type, offset, sortBy) => {
    return this.props.dispatch(UserItemActions.getUserItems(type, offset, PAGE_SIZE, sortBy)).catch((err) => {
      logError({ error: err, context: `UserItemsPage#getNextUserItems Failed to load ${type} items. Server error.` });
      this.setState({
        error: true,
        loading: false,
      });
    });
  };

  handleSortChange = (event) => {
    const { dispatch, userItemType } = this.props;
    const sortBy = event.target.value;

    this.setState({ sortBy });

    emitTrackSortListingsEvent({
      triggerLocation: 'user_item_list_page',
      triggerObject: 'user_item_page|header',
    });
  };

  handleLoginRedirect = () => {
    window.router.transitionTo(pathsManifest.LoginPage + '?redirect=' + pathsManifest.MyListPage);
  };

  handleBrowseClick = () => {
    const { dispatch } = this.props;
    dispatch(RouteActions.transitionToAreaWithMapData());
  };

  renderListings = () => {
    const { sortBy } = this.state;

    const [listings, totalCount, userItemTypes] = this.getPropsForActiveTab();
    let trigggerObject = 'my_hub_component|last_viewed';

    if (this.isFavoritesTab()) {
      trigggerObject = 'my_hub_component|favorite';
    }

    if (this.isContactTab()) {
      trigggerObject = 'my_hub_component|contact';
    }

    return (
      <>
        <ul className="MyListingPage-unorderedList">
          {map(listings, (listing) => {
            return (
              <ListingWrapper
                setActiveMarkerOnHover={false}
                key={listing.aliasEncoded}
                itemType="favorite"
                listing={listing}
                triggerLocation="my_hub_page"
                trigggerObject={trigggerObject}
              />
            );
          })}
        </ul>
        <Pagination
          maxItemsPerPage={PAGE_SIZE}
          totalItems={totalCount}
          onClick={(offset) => this.getUserItems(userItemTypes, offset, sortBy)}
          {...this.props}
        />
      </>
    );
  };

  linkTo = (index, offset) => {
    const { query, pathname } = this.props;

    let newQuery = omit(query, ['start', 'index']);

    if (offset !== 0) {
      newQuery = assign(newQuery, { start: offset });
    }

    if (index !== 0) {
      newQuery = assign(newQuery, { index });
    }

    return routeUtils.buildPathWithQuery(pathname, newQuery);
  };

  renderTabContent = () => {
    const { isLoggedIn } = this.props;
    const { error, loading, sortBy } = this.state;

    const [, totalItems] = this.getPropsForActiveTab();
    const loggedOut = !isLoggedIn;
    const loggedInNoListings = isLoggedIn && !loading && !error && totalItems === 0;
    const loggedInHasListings = isLoggedIn && !loading && !error && totalItems > 0;

    return (
      <>
        {loggedOut && (
          <Center>
            <S.MyListPageTitle>We're excited for you to easily manage your shortlist of properties!</S.MyListPageTitle>
            <S.MyListPageDescription>
              <StyledDarkText size="sm">
                Sign in or register to see your favorite and contact history on any device you use.
              </StyledDarkText>
            </S.MyListPageDescription>
            <Row>
              <Button onClick={this.handleLoginRedirect}>Sign in / Register</Button>
            </Row>
          </Center>
        )}

        {loggedInHasListings && (
          <S.MyListPageSortButton
            className={cx({
              'UserItemsPage-sort-dropdown-lg': sortBy === 'default',
            })}
          >
            <Select value={sortBy} onChange={this.handleSortChange} aria-label="Sort by">
              <option value="default">Sort: Date (recent first)</option>
              <option value="lowPrice">Sort: Lowest price</option>
              <option value="highPrice">Sort: Highest price</option>
              <option value="updated">Sort: Date updated</option>
            </Select>
          </S.MyListPageSortButton>
        )}

        {loggedInNoListings && (
          <Center>
            <S.MyListPageTitle>Hey there! Your list is empty.</S.MyListPageTitle>
            <S.MyListPageDescription>
              <StyledDarkText size="sm">Properties you favorite and contact show up here.</StyledDarkText>
            </S.MyListPageDescription>
            <Row>
              <Button onClick={this.handleBrowseClick}>Explore what's available</Button>
            </Row>
          </Center>
        )}

        <div className="MyListingPage-container">{loggedInHasListings && this.renderListings()}</div>
      </>
    );
  };

  getPropsForActiveTab() {
    let listings = [];
    let userItemTypes = '';

    if (this.isFavoritesTab()) {
      listings = this.props.userFavorites;
      userItemTypes = constants.FAVORITE;
    } else if (this.isContactTab()) {
      listings = this.props.userInquiried;
      userItemTypes = constants.INQUIRY;
    } else if (this.isAllTab()) {
      listings = this.props.userFavoriteAndInquired;
      userItemTypes = constants.FAVORITE_AND_INQUIRY;
    }

    return [listings, listings.length, userItemTypes];
  }

  isAllTab() {
    return (
      isEmpty(this.props.query) || parseInt(this.props.query.index) === 0 || Object.keys(this.props.query).length === 1
    );
  }

  isFavoritesTab() {
    return parseInt(this.props.query.index) === 1;
  }

  isContactTab() {
    return parseInt(this.props.query.index) === 2;
  }

  render() {
    const { isLoggedIn, query, userFavorites, userInquiried, userFavoriteAndInquired } = this.props;
    const { error, loading } = this.state;
    const favorite = userFavorites.length;
    const inquiry = userInquiried.length;
    const totalItems = userFavoriteAndInquired.length;
    const index = parseInt(query.index) || 0;
    const loggedInLoading = isLoggedIn && loading;

    return (
      <S.MyListPage className={cx('MyListPage')}>
        <Head title="My List - HotPads" />

        <Container>
          <UserItemsTitleBar>My list</UserItemsTitleBar>
          <Section>
            {error && (
              <Center>
                <Row>There was an error fetching your listings.</Row>
              </Center>
            )}

            {loggedInLoading && <Spinner className="Spinner-container" />}

            {!loading && (
              <StyledTabGroup defaultIndex={index} evenSpiltWidth={false}>
                <TabItem
                  className={cx('TabGroup-my-list-tab', {
                    'TabGroup-my-list-active': index === 0,
                  })}
                  tabTitle={`All (${totalItems})`}
                  onClick={() => {
                    window.router.transitionTo(this.linkTo(0, 0));
                  }}
                >
                  {this.renderTabContent()}
                </TabItem>
                <TabItem
                  className={cx('TabGroup-my-list-tab', {
                    'TabGroup-my-list-active': index === 1,
                  })}
                  tabTitle={`Favorited (${favorite})`}
                  onClick={() => {
                    window.router.transitionTo(this.linkTo(1, 0));
                  }}
                >
                  {this.renderTabContent()}
                </TabItem>
                <TabItem
                  className={cx('TabGroup-my-list-tab', {
                    'TabGroup-my-list-active': index === 2,
                  })}
                  tabTitle={`Contacted (${inquiry})`}
                  onClick={() => {
                    window.router.transitionTo(this.linkTo(2, 0));
                  }}
                >
                  {this.renderTabContent()}
                </TabItem>
              </StyledTabGroup>
            )}
          </Section>
        </Container>
      </S.MyListPage>
    );
  }
}

const selectUserFavoriteAndInquired = (state) => {
  const listingGroups = get(state, 'listings.listingGroups');
  const combinedListings = [...listingGroups.favorite, ...listingGroups.inquired];
  return uniqBy(combinedListings, 'aliasEncoded');
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.user.loggedIn,
    userFavorites: state.listings.listingGroups.favorite || [],
    userInquiried: state.listings.listingGroups.inquired || [],
    // below is example of where a "selector" pattern can be used to clean up code
    userFavoriteAndInquired: selectUserFavoriteAndInquired(state),
    query: state.location.current.query,
    pathname: state.location.current.pathname,
  };
};

export default withRouter(connect(mapStateToProps)(MyListPage));
